<template>
  <div>
    <Header>
      Statystyki
    </Header>

    <h6>Liczba rezerwacji miesięcznie ogólnie</h6>
    <BarChart :chart-data="chartData_reservations_count_list" :chart-options="chartOptions"/>

    <h6 class="mt-3">Liczba rezerwacji miesięcznie na fryzjera</h6>
    <LineChart :chart-data="chartData_reservations_count_list_per_barber" :chart-options="chartOptions"/>

    <h6 class="mt-3">Średnia liczba rezerwacji na miesiąc</h6>
    <PolarAreaChart :chart-data="chartData_average_reservations_per_month"/>
  </div>
</template>

<script>
import Layout from '@/Layouts/Default'
import Header from '@/Layouts/Components/Header'
import {
  Bar as BarChart,
  Line as LineChart,
  Doughnut as DoughnutChart,
  PolarArea as PolarAreaChart
} from 'vue-chartjs/legacy'

export default {
  layout: Layout,
  components: {
    Header,
    BarChart,
    LineChart,
    DoughnutChart,
    PolarAreaChart,
  },
  props: {
    reservations_count_list: Array,
    barbers_data: Array,
  },
  computed: {
    chartData_reservations_count_list() {
      const min = Math.min(...this.reservations_count_list.filter((i) => i.data).map((i) => i.data))
      const max = Math.max(...this.reservations_count_list.map((i) => i.data))
      return {
        labels: this.reservations_count_list.map((i) => i.month_name),
        datasets: [
          {
            label: 'Ogólnie',
            backgroundColor: this.reservations_count_list.map((i) => window.interpolateBetweenColors(
              {r: 127, g: 183, b: 126},
              {r: 220, g: 220, b: 220},
              (i.data - min) / (max - min)
            )),
            data: this.reservations_count_list.map((i) => i.data)
          }
        ]
      }
    },
    chartData_reservations_count_list_per_barber() {
      const datasets = [];
      for (const i of this.barbers_data) {
        datasets.push({
          label: i.barber_name,
          borderColor: window.stringToColor(i.barber_name + '1024'),
          data: i.reservations_count_list.map((i) => i.data)
        })
      }
      return {
        labels: this.reservations_count_list.map((i) => i.month_name),
        datasets: datasets
      }
    },
    chartData_average_reservations_per_month() {
      return {
        labels: this.barbers_data.map((i) => i.barber_name),
        datasets: [{
          data: this.barbers_data.map((i) => i.average_reservations_per_month),
          backgroundColor: this.barbers_data.map((i) => window.stringToColor(i.barber_name + '1024')),
        }]
      }
    },
    chartOptions() {
      return {
        scales: {
          y: {
            beginAtZero: false
          }
        }
      }
    },
  },
}
</script>
